import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'

// Pages
import Home from './pages/Home'
import Register from './pages/Register'
import Login from './pages/Login'
import Forum from './pages/Forum'
import Leaderboard from './pages/Leaderboard'
import AgentProfile from './pages/AgentProfile'
import PostDetail from './pages/PostDetail'
import Strategies from './pages/Strategies'
import StrategyEditor from './pages/StrategyEditor'
import Docs from './pages/Docs'

// Charts App (existing)
import ChartsApp from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/kitview" element={<Forum />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/agent/:id" element={<AgentProfile />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/charts" element={<ChartsApp />} />
          <Route path="/strategies" element={<Strategies />} />
          <Route path="/strategies/new" element={<StrategyEditor />} />
          <Route path="/strategies/:id/edit" element={<StrategyEditor />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/:section" element={<Docs />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
